module.exports = __webpack_public_path__ + "static/media/21ECLAC36.1d8ea8ca.jpg";